import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('sparepart-list/index', {params});
    },
    getSparepart(params) {
        return Service().get('sparepart-list/get-spare-part', {params});
    },
    show(id) {
        return Service().get('sparepart-list/show/'+id);
    },
    create(params) {
        return Service().post('sparepart-list/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('sparepart-list/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('sparepart-list/delete/'+id);
    },
}